/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { getMonths } from 'shared/constants';
import { useTranslation } from 'react-i18next';
import {
  getFirstDayOfMonth,
  getFirstDayOfWeek,
  getFirstDayOfYear,
  getLastDayOfMonth,
  getLastDayOfWeek,
  getLastDayOfYear,
  getNewDate
} from 'shared/utils';
import { useEventsContext } from 'hooks/useContexts';

export default function SelectArrowDate({
  currentDate,
  setCurrentDate,
  view,
  customStyle = {},
  setRangeDate = ({ startDate, endDate }) => {}
}) {
  const { usersTimezoneLocation } = useEventsContext();
  const { t } = useTranslation();
  const months = getMonths(t);

  const changeRangeDates = (view) => {
    if (view === 'day') {
      setRangeDate({
        startDate:
          getNewDate({
            date: currentDate,
            usersTimezoneLocation,
            getISODateFromUsersTimezone: true
          }).split('T')[0] + 'T00:00:00.000Z',
        endDate:
          getNewDate({
            date: currentDate,
            usersTimezoneLocation,
            getISODateFromUsersTimezone: true
          }).split('T')[0] + 'T23:59:59.999Z'
      });
    } else if (view === 'week') {
      setRangeDate({
        startDate: getFirstDayOfWeek({
          date: getNewDate({
            date: currentDate,
            usersTimezoneLocation,
            getISODateFromUsersTimezone: true
          })
        }),
        endDate: getLastDayOfWeek({
          date: getNewDate({
            date: currentDate,
            usersTimezoneLocation,
            getISODateFromUsersTimezone: true
          })
        })
      });
    } else if (view === 'month') {
      setRangeDate({
        startDate: getFirstDayOfMonth({
          date: getNewDate({
            date: currentDate,
            usersTimezoneLocation,
            getDateObjectFromUsersTimezone: true
          })
        }),
        endDate: getLastDayOfMonth({
          date: getNewDate({
            date: currentDate,
            usersTimezoneLocation,
            getDateObjectFromUsersTimezone: true
          })
        })
      });
    } else if (view === 'yearly') {
      setRangeDate({
        startDate: getFirstDayOfYear(currentDate.getFullYear()),
        endDate: getLastDayOfYear(currentDate.getFullYear())
      });
    }
  };

  const [weekRange, setWeekRange] = useState(
    `${getFirstDayOfWeek({
      date: getNewDate({ isUTC0: true, date: currentDate }),
      toShow: true,
      t
    })} - ${{
      date: getNewDate({ isUTC0: true, date: currentDate }),
      toShow: true,
      t
    }}`
  );

  const [year, setYear] = useState(currentDate.toString().split(' ')[3]);

  const [currentDay, setCurrentDay] = useState(
    `${currentDate.toString()?.split(' ')[2]} ${
      currentDate.toString()?.split(' ')[1]
    } ${currentDate.toString()?.split(' ')[3]}`
  );

  const applyChangesToView = () => {
    changeRangeDates(view);
    setYear(currentDate.toString().split(' ')[3]);
    setCurrentDay(
      `${currentDate.toString()?.split(' ')[2]} ${
        currentDate.toString()?.split(' ')[1]
      } ${currentDate.toString()?.split(' ')[3]}`
    );
    setWeekRange(
      `${getFirstDayOfWeek({
        date: getNewDate({ isUTC0: true, date: currentDate }),
        toShow: true,
        t
      })} - ${getLastDayOfWeek({
        date: getNewDate({ isUTC0: true, date: currentDate }),
        toShow: true,
        t
      })}`
    );
  };

  useEffect(() => {
    applyChangesToView();
  }, [view]);

  return (
    <div className={styles.wrapper} style={customStyle}>
      <div className={styles.arrows}>
        {view !== 'yearly' && (
          <img
            src={'/images/left_double_arrows.svg'}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setCurrentDate(
                view === 'day'
                  ? getNewDate({
                      date: new Date(
                        currentDate.setMonth(currentDate.getMonth() - 1)
                      ),
                      usersTimezoneLocation,
                      getDateObjectFromUsersTimezone: true
                    })
                  : getNewDate({
                      date: new Date(
                        currentDate.setYear(currentDate.getFullYear() - 1)
                      ),
                      usersTimezoneLocation,
                      getDateObjectFromUsersTimezone: true
                    })
              );
              applyChangesToView();
            }}
          />
        )}
        <img
          src={'/images/month_picker_left_arrow.svg'}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (view === 'day' || view === 'month') {
              setCurrentDate(
                view === 'day'
                  ? getNewDate({
                      date: new Date(
                        currentDate.setUTCDate(currentDate.getUTCDate() - 1)
                      ),
                      usersTimezoneLocation,
                      getDateObjectFromUsersTimezone: true
                    })
                  : getNewDate({
                      date: new Date(
                        currentDate.setMonth(currentDate.getMonth() - 1)
                      ),
                      isUTC0: true,
                      // usersTimezoneLocation,
                      // getDateObjectFromUsersTimezone: true
                    })
              );
            } else if (view === 'yearly') {
              setCurrentDate(
                getNewDate({
                  date: new Date(
                    currentDate.setFullYear(currentDate.getFullYear() - 1)
                  ),
                  usersTimezoneLocation,
                  getDateObjectFromUsersTimezone: true
                })
              );
            } else if (view === 'yearly') {
              setCurrentDate(
                new Date(currentDate.setFullYear(currentDate.getFullYear() - 1))
              );
              setYear(currentDate.toString().split(' ')[3]);
            } else {
              //weekly
              setCurrentDate(
                getNewDate({
                  date: new Date(
                    currentDate.setUTCDate(currentDate.getUTCDate() - 7)
                  ),
                  usersTimezoneLocation,
                  getDateObjectFromUsersTimezone: true
                })
              );
            }
            applyChangesToView();
          }}
        />
      </div>
      {view === 'month' ? (
        <span>
          {t(
            months.find((month) => {
              return (
                month.short.toLowerCase() ===
                t(
                  currentDate.toString()?.split(' ')[1].toLowerCase()
                ).toLowerCase()
              );
            })?.name
          )}{' '}
          {currentDate.toString()?.split(' ')[3]}
        </span>
      ) : view === 'week' ? (
        <span>{weekRange}</span>
      ) : view === 'yearly' ? (
        <span>{year}</span>
      ) : (
        <span>{currentDay}</span>
      )}
      <div className={styles.arrows}>
        <img
          src={'/images/month_picker_right_arrow.svg'}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (view === 'day' || view === 'month') {
              setCurrentDate(
                view === 'day'
                  ? getNewDate({
                      date: new Date(
                        currentDate.setUTCDate(currentDate.getUTCDate() + 1)
                      ),
                      usersTimezoneLocation,
                      getDateObjectFromUsersTimezone: true
                    })
                  : getNewDate({
                      date: new Date(
                        currentDate.setMonth(currentDate.getMonth() + 1)
                      ),
                      isUTC0: true,
                      // usersTimezoneLocation,
                      // getDateObjectFromUsersTimezone: true
                    })
              );
            } else if (view === 'yearly') {
              setCurrentDate(
                getNewDate({
                  date: new Date(
                    currentDate.setFullYear(currentDate.getFullYear() + 1)
                  ),
                  usersTimezoneLocation,
                  getDateObjectFromUsersTimezone: true
                })
              );
              setYear(currentDate.toString().split(' ')[3]);
            } else {
              setCurrentDate(
                getNewDate({
                  date: new Date(
                    currentDate.setUTCDate(currentDate.getUTCDate() + 7)
                  ),
                  usersTimezoneLocation,
                  getDateObjectFromUsersTimezone: true
                })
              );
            }
            applyChangesToView();
          }}
        />
        {view !== 'yearly' && (
          <img
            src={'/images/right_double_arrows.svg'}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setCurrentDate(
                view === 'day'
                  ? getNewDate({
                      date: new Date(
                        currentDate.setMonth(currentDate.getMonth() + 1)
                      ),
                      usersTimezoneLocation,
                      getDateObjectFromUsersTimezone: true
                    })
                  : getNewDate({
                      date: new Date(
                        currentDate.setYear(currentDate.getFullYear() + 1)
                      ),
                      usersTimezoneLocation,
                      getDateObjectFromUsersTimezone: true
                    })
              );
              applyChangesToView();
            }}
          />
        )}
      </div>
    </div>
  );
}
